<script setup lang="ts">
import { useAuth } from '@/composables/useAuth'
import { onMounted } from 'vue'

const auth = useAuth()

onMounted(() => {
  auth.signOut()
})
</script>

<template>
  <div class="h-100 d-flex justify-center align-center">
    <v-progress-circular
      color="brand-primary"
      size="48"
      indeterminate
    />
  </div>
</template>
